import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-flucs.svg";
import * as styles from "./Icon.module.scss";

type FlucsProps = React.SVGProps<SVGSVGElement>;

export const Flucs = ({ className, ...props }: FlucsProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
